import React, { memo } from "react";
import { Box } from "@chakra-ui/layout";
import { SkeletonText } from "@chakra-ui/react";
import { Table, Tbody, Td, Th, Tr, Thead } from "@chakra-ui/table";
import { CherryHubAdminApi } from "../../api/adminApiModels";
import { CopyText } from "../Utilities/CopyText";

interface TwilioBillingUsagesTableProps {
  data: CherryHubAdminApi.TwilioBillingAccount[] | null | undefined;
  isLoading: boolean;
}

export const TwilioBillingUsagesTable = memo(
  ({ data, isLoading }: TwilioBillingUsagesTableProps) => {
    return (
      <Box w="100%" overflowX="auto">
        <Table size="sm">
          <Thead>
            <Tr>
              <Th whiteSpace="nowrap">Account Id</Th>
              <Th whiteSpace="nowrap">Account Name</Th>
              <Th whiteSpace="nowrap" textAlign="right">
                Cost
              </Th>
              <Th whiteSpace="nowrap" textAlign="right">
                Count
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {!isLoading &&
              (data ?? []).map((item, dataIdx) => (
                <Tr key={dataIdx}>
                  <Td width="20%" whiteSpace="nowrap" title="Copy accoount id.">
                    <CopyText hover={true}>{item.AccountId!}</CopyText>
                  </Td>
                  <Td>{item.SmsSenderId!}</Td>
                  <Td width="0.1%" whiteSpace="nowrap" textAlign="right">
                    {item.UsagePrice?.toFixed(2) ?? "-"}{" "}
                    {item.UsagePriceUnit?.toUpperCase() ?? "USD"}
                  </Td>
                  <Td width="0.1%" whiteSpace="nowrap" textAlign="right">
                    {item.UsageCount ?? "-"}
                  </Td>
                </Tr>
              ))}
            {isLoading && (
              <Tr>
                <Td width="20%">
                  <SkeletonText noOfLines={12} spacing="4" width="100%" />
                </Td>
                <Td width="50%">
                  <SkeletonText noOfLines={12} spacing="4" width="100%" />
                </Td>
                <Td width="15%" whiteSpace="nowrap">
                  <SkeletonText noOfLines={12} spacing="4" width="100%" />
                </Td>
                <Td width="15%" whiteSpace="nowrap">
                  <SkeletonText noOfLines={12} spacing="4" width="100%" />
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </Box>
    );
  }
);
